import type { App } from 'vue'
import type { AppRegistry } from '../types'

export default (): AppRegistry => {
  const appRegistry: Map<string, App<Element>> = new Map()

  const clearRegistry = (): void => {
    appRegistry.forEach((app) => {
      app.unmount()
    })
    appRegistry.clear()
  }

  const configureRegistry = (): void => {
    document.addEventListener('turbolinks:before-cache', clearRegistry)

    document.addEventListener('turbolinks:before-render', clearRegistry)
  }

  const persistApp = (app: App<Element>, singletonId?: string): void => {
    if (retrieveApp(singletonId)) {
      return
    }

    if (singletonId) {
      appRegistry.set(singletonId, app)
    }
  }

  const resetRegistry = (): void => {
    clearRegistry()
    document.removeEventListener('turbolinks:before-cache', clearRegistry)
    document.removeEventListener('turbolinks:before-render', clearRegistry)
  }

  const retrieveApp = (singletonId?: string): App<Element> | undefined => {
    if (singletonId) {
      return appRegistry.get(singletonId)
    }
  }

  return {
    configureRegistry,
    persistApp,
    resetRegistry,
    retrieveApp,
  }
}
